import client from '@/api';

export default {

    getCostTypes: () => client.execute('get', 'costables/cost-types'),

    getCostNominalCodes: () => client.execute('get', 'costables/cost-nominal-codes'),

    getCostStatuses: () => client.execute('get', 'costables/cost-statuses'),

    getSecondaryCostStatuses: () => client.execute('get', 'costables/cost-statuses?type=secondary'),

    getResourceTypes: supplierId => client.execute('get', `costables/resource-types?supplier_id=${supplierId}`),

    getIndustryTypes: () => client.execute('get', 'costables/industry-types'),

    getTransactionTypes: () => client.execute('get', 'costables/transaction-types'),

    getTeams: () => client.execute('get', 'costables/teams'),

    getUserTeam: () => client.execute('get', 'costables/user-team'),

    getAccountTypes: () => client.execute('get', 'costables/account-types'),

    getSources: () => client.execute('get', 'costables/sources'),

    getMediums: () => client.execute('get', 'costables/mediums'),

    getUsers: () => client.execute('get', 'users'),

    getEventStatuses: () => client.execute('get', 'costables/event-statuses'),

    getTags: () => client.execute('get', 'costables/tags'),

    getTaxRates: () => client.execute('get', 'costables/tax-rates'),

};

